import styled from "styled-components";
import { Modal } from "components/Modal";

export const CreateSurmountAccountModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 100%;
    width: 100%;
    height: 100vh;
    margin: 0;
    max-height: 100vh;

    .modal-content {
      padding: 0;
      border-radius: 0;
      border-left: none;
      border-right: none;
      height: 100vh;
      max-height: 100vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .modal-body {
        padding: 0;
        overflow-y: auto;
        overflow-x: visible;
        flex: 1;
        min-height: 0;
      }
    }
  }

  .modal-content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;

    > div:first-child {
      width: 100%;
      max-width: 892px;
      margin: 0 auto;
      max-height: 100% !important;
      padding: 32px 40px;
      height: auto;
    }

    /* Ensure proper scrolling within modal */
    .signup-flow-header {
      margin-bottom: 24px;
    }

    /* Adjust footer positioning in modal */
    footer {
      position: sticky;
      bottom: 0;
      background: white;
      padding-top: 16px;
      margin-top: auto;
    }

    /* Step-based styling for SignupFlowWrapperContainer and SignupFlowContent */
    &[data-step="PERSONAL_DETAILS"],
    &[data-step="PHONE_VERIFICATION"],
    &[data-step="INVESTMENT_GOALS"],
    &[data-step="REVIEW_SUBMIT"] {
      /* Set CSS custom properties that will be inherited by SignupFlowWrapperContainer and SignupFlowContent */
      --signup-flow-justify-content: normal;
      --signup-flow-flex: 0;
    }
  }

  /* Ensure calendar popup appears above modal */
  .react-datepicker-popper {
    z-index: 9999 !important;
  }

  .react-datepicker__portal {
    z-index: 9999 !important;
  }

  /* Portal container for date picker */
  #personal_details_date_of_birth {
    z-index: 9999 !important;
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0;
      height: 100vh;

      .modal-content {
        max-height: 100vh;
        border-radius: 0;
      }
    }

    .modal-content-wrapper {
      > div:first-child {
        padding: 24px 20px;
        max-height: calc(100vh - 40px);
      }
    }
  }
`;

export const ModalHeader = styled.div`
  padding: 32px 40px;
  max-width: 892px;
  margin: 0 auto;
  width: 100%;
  border-bottom: 1px solid #e9eaeb;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 768px) {
    padding: 24px 20px;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  color: #858d9d;
  transition: color 0.2s;

  &:hover {
    color: #181d27;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 16px;
  font-weight: 400;
  color: #181d27;
  margin: 0 0 20px 0;
  font-family: "Geist", sans-serif;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 32px;
  padding-bottom: 0;
`;

export const Tab = styled.button`
  background: none;
  border: none;
  padding: 0 0 12px 0;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => {
    if (props.disabled) return "#D5D7DA";
    return props.$active ? "#1841DD" : "#858D9D";
  }};
  cursor: ${(props) => {
    if (props.disabled) return "not-allowed";
    return props.$active ? "default" : "pointer";
  }};
  border-bottom: ${(props) => {
    if (props.disabled) return "none";
    return `2px solid ${props.$active ? "#1841DD" : "transparent"}`;
  }};
  transition: all 0.2s;
  position: relative;
  font-family: "Geist", sans-serif;
  line-height: 20px;
  margin-bottom: -2px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &[disabled],
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border: none !important;
  }

  &:hover {
    color: ${(props) => {
      if (props.disabled) return "#D5D7DA";
      return props.$active ? "#1841DD" : "#535862";
    }};
  }
`;

export const ProcessingScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  min-height: 100%;
  text-align: center;
  max-width: 892px;
  margin: 0 auto;
  width: 100%;

  .container-processing {
    background: rgb(245, 245, 245);
    padding: 32px 40px;
    border-radius: 16px;
    max-width: 828px;
    width: 100%;
    height: 828px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: visible;
  }

  @media (max-width: 768px) {
    padding: 60px 20px;
    .container-all-set {
      height: auto;
    }
  }
`;

export const ProcessingIconWrapper = styled.div`
  width: 140px;
  height: 140px;

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
    margin-bottom: 24px;
  }
`;

export const ProcessingTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #2258f1;
  margin: 0 0 16px 0;
  font-family: "Geist", sans-serif;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const ProcessingDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: rgba(10, 13, 18, 0.7);
  margin: 0 0 24px 0;
  font-family: "Geist", sans-serif;
  line-height: 24px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ProcessingButtonWrapper = styled.div`
  width: 100%;
  max-width: 300px;

  @media (max-width: 768px) {
    max-width: 100%;
  }

  button {
    border-radius: 8px;
    border: 1px solid #d5d7da;
    background: white;
    box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
      0 -2px 0 0 rgba(10, 13, 18, 0.05) inset,
      0 1px 2px 0 rgba(10, 13, 18, 0.05);
    padding: 10px 14px;
    font-size: 14px;
  }
`;

export const AllSetScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  min-height: 100%;
  text-align: center;
  max-width: 892px;
  margin: 0 auto;
  width: 100%;

  .container-all-set {
    background: rgb(245, 245, 245);
    padding: 32px 40px;
    border-radius: 16px;
    max-width: 828px;
    width: 100%;
    height: 828px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: visible;
  }

  @media (max-width: 768px) {
    padding: 60px 20px;
    .container-all-set {
      height: auto;
    }
  }
`;

export const AllSetIconWrapper = styled.div`
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }
`;

export const AllSetTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #2258f1;
  margin: 0 0 16px 0;
  font-family: "Geist", sans-serif;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const AllSetDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: rgba(10, 13, 18, 0.7);
  margin: 0 0 24px 0;
  font-family: "Geist", sans-serif;
  line-height: 24px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const AllSetButtonWrapper = styled.div`
  width: 100%;
  max-width: 300px;

  @media (max-width: 768px) {
    max-width: 100%;
  }

  button {
    border-radius: 8px;
    border: 1px solid #d5d7da;
    background: white;
    box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
      0 -2px 0 0 rgba(10, 13, 18, 0.05) inset,
      0 1px 2px 0 rgba(10, 13, 18, 0.05);
    padding: 10px 14px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #f5f6f7;
    }
  }
`;
